import { FCC } from "@/types/common";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { Avatar, Grid, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import { deepOrange, deepPurple, blue, green, pink, amber } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { CompanyInfoItem } from "@/features/company/components/company-detail/CompanyInfoItem";
import { secondary } from "@/theme/colors";
import { IconCopyEmail } from "@/assets/icons/IconCopyEmail";
import { useParams } from "react-router-dom";

type TCompanyContactInfoProps = {
  defaultValues: Partial<TCompanyForm>;
};

const colors = [deepOrange[500], deepPurple[500], blue[500], green[500], pink[500], amber[500]];
const getRandomColor = () => {
  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
};
export const CompanyContactInfo: FCC<TCompanyContactInfoProps> = ({ defaultValues }) => {
  const { companyId } = useParams();
  const [bgColor] = useState<string>(() => {
    const savedColor = localStorage.getItem(`companyBgColor_${companyId}`);
    if (savedColor) return savedColor;
    const newColor = getRandomColor();
    localStorage.setItem(`companyBgColor_${companyId}`, newColor);
    return newColor;
  });
  const [firstChar, setFirstChar] = useState<string>();
  const [messageTooltip, setMessageTooltip] = useState<string>("メールアドレスをコピー");
  const copyEmail = async () => {
    setMessageTooltip("メールアドレスをコピーしました。");
    const value = defaultValues.contactPersonEmail;
    try {
      if (typeof value === "string") {
        await navigator.clipboard.writeText(value);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (defaultValues.contactPersonName) {
      const char = defaultValues.contactPersonName.charAt(0).toUpperCase();
      setFirstChar(char);
    }
  }, [defaultValues.contactPersonName]);
  return (
    <InnerBox title={<CompanyFormTitle text="担当者情報" />} showDivider={false}>
      <Grid
        container
        spacing={3}
        sx={{
          marginBottom: "16px",
        }}
      >
        <Grid item xs={6}>
          <Stack direction="row" gap={2}>
            <Stack direction="column" alignContent="center" flexWrap="nowrap" justifyContent="center">
              <Avatar sx={{ width: 32, height: 32, bgcolor: bgColor, marginBottom: "20px" }}>{firstChar}</Avatar>
            </Stack>
            <Stack width="100%">
              <CompanyInfoItem label="名前" value={defaultValues?.contactPersonName} />
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <CompanyInfoItem label="役職" value={defaultValues?.contactPersonJobTitle} />
        </Grid>
        <Grid item xs={6}>
          <CompanyInfoItem label="電話番号" value={defaultValues?.contactPersonPhone} isShowDivider={false} type="phone" />
        </Grid>
        <Grid item xs={6}>
          <CompanyInfoItem
            color={defaultValues?.contactPersonEmail ? secondary[80] : ""}
            label="メールアドレス"
            value={defaultValues?.contactPersonEmail}
            endIcon={
              <Tooltip title={messageTooltip} placement="top-start" onClick={copyEmail}>
                <Typography>
                  <IconCopyEmail />
                </Typography>
              </Tooltip>
            }
            isShowDivider={false}
          />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
